import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TerritoriumService } from '../../services/territorium/territorium.service';
import { TokenControlService } from '../../../app/services/state/tokenControl.service';

@Component({
  selector: 'app-verificacion',
  templateUrl: './verificacion.component.html',
  styleUrls: ['./verificacion.component.css']
})
export class VerificacionComponent implements OnInit {

  public error = [];
  public loading: Boolean = false;
  public mainCounterError = 0;
  public successMessage: string = "Pre registro finalizado de forma Exitosa !"

  private steps: Step[] = [
    {
      title: 'Captura de Fotografía',
      step: 1,
      pantalla: 0,
      pantallas: 2,
      picture: undefined
    },
    {
      title: 'Captura de documento',
      step: 2,
      pantalla: 0,
      pantallas: 2,
      picture: undefined
    },
    {
      title: 'Verificación final',
      step: 3,
      pantalla: 0,
      pantallas: 4
    }
  ]

  private stepsCopy: Step[];

  public errorService1: string = "Ha ocurrido un error inesperado con la BD TERRITORIUM, CODE S1";
  public errorService2: string = "Ha ocurrido un error inesperado con la BD TERRITORIUM,  CODE S2";
  public errorService3: string = "Ha ocurrido un error inesperado con la BD PLEXI,  CODE S3";

  public step = this.steps.find(e => e.step == 1);

  verificationRequestErrors: Map<string, string> = new Map([
    ['message-error-1', 'Hubo un error en la validación'],
    ['message-error-2', 'Su identidad no pudo ser verificada. Reinicia el proceso y toma las fotos nuevamente.'],
    ['message-Id-noface', 'No se detectaron rostros en la imagen'],
    ['message-Id-diffPerson', 'No es la misma persona en las fotografías'],
    ['message-noId', 'No se detectó una identificación'],
    ['message-Id-wrong', 'Se detectó una identificación en la primera imagen'],
    ['message-Id-problems', 'Hubo problemas al procesar las fotografías. Intenta de nuevo, por favor.'],
    ['message-Id-wrong-previous', 'Se detectó una identificación en la imagen previa'],
    ['message-Id-noface-previous', 'No se detectaron rostros en la imagen previa'],
    ['message-Id-problems-previous', 'Hubo problemas al procesar las fotografías previas. Intenta de nuevo, por favor.'],
    ['message-Id-diffPerson-previous', 'No es la misma persona en las fotografías previas'],
    ['message-not-data', 'No se pudo realizar la validación'],
  ])

  public constructor(private _router: Router,
    private _tokenController: TokenControlService,
    private _territoriumService: TerritoriumService) { }

  public ngOnInit() {
    this.stepsCopy = this.steps.map(x => Object.assign({}, x));
  }

  forward(jump: number): void {
    const SCREENS = this.step.pantallas;
    if (this.isJumpScreen(SCREENS, jump)) {
      this.step.pantalla += jump;
    } else {
      this.step = this.steps.find(e => e.step == this.step.step + 1);
    }
  }

  private isJumpScreen(screens: number, jump: number) {
    return screens > (this.step.pantalla + jump);
  }

  capturePic(e: Array<any>, step: number): void {
    this.step.picture = e[0];
      setTimeout(() => this.updateDomPic(step == 1 ? 'personPic': 'personPic2'), 10);
  }

  private updateDomPic(id: string): void {
    var img = document.getElementById(id) as any;
    img.src = this.step.picture;
  }

  restart(): void {
    this.steps = this.stepsCopy.map(x => Object.assign({}, x));
    this.step = this.steps[0];
  }

  verify(): void {
    this.areAttempsOver() ? this.verifyTeritoriumPicManual() : this.verifyTerritoriumPic();
  }

  areAttempsOver = () => this.mainCounterError == 3;

  verifyTerritoriumPic(): void {
    this._territoriumService.sendPicVerification(this.getRequestData()).subscribe(({ errores, messages }) => {
      if (errores === 0) {
        this.updateBDPlexi(UserState.REGISTERED);
        return;
      }
      if (errores > 0) {
        this.mainCounterError++;
        this.errorRequest(messages.reduce((acu, curr) => acu.concat(this.verificationRequestErrors.has(curr) ?
          this.verificationRequestErrors.get(curr) : this.errorService1), []));
        return;
      }
    }, () => this.errorRequest([this.errorService1]));
  }

  private getRequestData(): any {
    const CREDENCIAL = this._tokenController.token.credentialId + "";
    const DATA = {
      "images": [this.steps[0].picture, this.steps[1].picture],
      "imagesPrevias": [],
      "matricula": CREDENCIAL,
      "params": {
        "applyRedirect": true, "subdomain": "icfes", "idUniversidad": "1727"
      }
    };
    return DATA;
  }

  verifyTeritoriumPicManual(): void {
    this._territoriumService.sendPicManualVerification(this.getRequestData()).subscribe((response: any) => {
      if (response.status === 200 && response.body.errores === 0) {
        this.updateBDPlexi(UserState.INVERIFICATION);
        this.successMessage = "Pre registro en espera de verificación manual por parte del ICFES"
      } else {
        this.errorRequest([this.errorService2])
      }
    }, () => this.errorRequest([this.errorService2]))
  }

  updateBDPlexi(newValue: number): void {
    const CREDENCIAL = this._tokenController.token.credentialId + "";
    const TOKEN = this._tokenController.token.token;
    const TOKENID = this._tokenController.token.tokenId;
    this._territoriumService.updatePic(CREDENCIAL, TOKEN, TOKENID, newValue).then(response => {
      if (response && response === true) {
        this.forward(1);
      } else {
        this.errorRequest([this.errorService3]);
      }
    }, () => this.errorRequest([this.errorService3]));
  }

  errorRequest(error: string[]): void {
    this.error = [... new Set(error)];
    this.forward(2);
  }

  salir = () => location.reload();
  sucess = () => this._router.navigate(['/welcome']);

}

interface Step {
  title: string,
  step: number,
  pantalla: number,
  pantallas: number,
  picture?: any
}

export enum UserState {
  REGISTERED = 2,
  UNREGISTERED = 0,
  INVERIFICATION = 1
}
